
import { Vue, Prop, Watch, Component, Ref } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import moment from "moment";
import { ORDER_FILTER_FIELDS, DYNAMIC_DATE_OPTIONS } from "@/consts";
import { FacilityModule } from "@/store/modules";

@Component
export default class SearchFilterEditor extends Vue {
  filterFields: any = null;
  localFilter: any = null;
  dateType: string = null;
  dynamicDateOptions: Array<any> = DYNAMIC_DATE_OPTIONS;
  isInactiveIncludeFacilities: boolean = false;
  isInactiveIncludeExcludeFacilities: boolean = false;
  facilityModule:FacilityModule = getModule(FacilityModule);

  $refs!: {
    input: HTMLInputElement;
  };

  @Prop({ required: false, default: () => null })
  type: string;

  @Prop({ required: false, default: () => null })
  filter: any;

  @Prop({ required: false, default: true })
  showName: boolean;

  @Prop({ required: false, default: false })
  showFacility: boolean;

  @Prop({ required: false, default: false })
  advancedSearch: boolean;

  @Prop({ required: false, default: false })
  isInactiveInclude: boolean;

  @Watch("filter")
  onFilterChange(val: any, oldVal: any) {
    this.localFilter = JSON.parse(JSON.stringify(val));

    if (this.localFilter === null) this.setupInitialFilter();
  }

  setFocusToNextField(fieldName: string | string[], index: number) {
    let refName = `${fieldName}_input`;

    this.$nextTick(() => {
      if (!this.$refs[refName]) return;
      this.$refs[refName][0].focus();
    });

    this.validSearchFields[index].filterValues = [];
    if (fieldName.includes("Date")) {
      this.validSearchFields[index].dateType = "fixed";
    }
  }

  created() {
    if (this.advancedSearch) this.filterFields = ORDER_FILTER_FIELDS;
    else this.filterFields = ORDER_FILTER_FIELDS.filter(x => !x.advancedOnly);

    this.filterFields = this.filterFields.sort(
      (a: { displayName: string }, b: { displayName: string }) => {
        let fa = a.displayName.toLowerCase(),
          fb = b.displayName.toLowerCase();

        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      }
    );

    if (!this.filter) {
      this.setupInitialFilter();
    } else {
      this.localFilter = this.filter;
    }
  }

  mounted() {
    this.isInactiveIncludeFacilities = this.isInactiveInclude;
    this.isInactiveIncludeExcludeFacilities = this.isInactiveInclude;
  }

  setupInitialFilter() {
    let initialFields = [];
    if (this.advancedSearch) {
      const defaultAdvancedFields = this.filterFields.filter(
        (x: { requiredForAdvancedSearch: any }) => x.requiredForAdvancedSearch
      );
      defaultAdvancedFields.forEach((advancedField: { name: string | string[] }) => {
        let values = [];
        if (advancedField.name.indexOf("Date") > -1) {
          const initial = moment()
            .add(-30, "days")
            .format("M/D/YYYY");
          const ending = moment().format("M/D/YYYY");
          values = [`${initial} ~ ${ending}`];
        }        
        initialFields.push({
          name: advancedField.name,
          required: true,
          filterValues: values,
          dateType: "fixed"
        });
      });
    }
    this.localFilter = { searchFields: initialFields };
  }
  unusedFilterFields(currentField: any) {
    return this.filterFields.filter(
      (x: { name: any }) =>
        x.name === currentField ||
        this.localFilter.searchFields.filter((y: { name: any }) => y.name === x.name) < 1
    );
  }

  getBooleanOptions() {
    return [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ];
  }

  getSelectedField(fieldName: any) {
    var relatedFields = this.filterFields.filter((x: { name: any }) => x.name === fieldName);
    if (relatedFields.length < 1) return null;
    return relatedFields[0];
  }

  removeFilter(index: number) {
    this.localFilter.searchFields.splice(index, 1);
  }

  addFilterField() {
    this.localFilter.searchFields.push({ name: null, filterValues: [], dateType: null });
  }

  clearField(selectedField: { filterValues: any[] }) {
    selectedField.filterValues[0] = null;
  }

  selectDateTime(selectedField: { dateType: any }, type: any) {
    selectedField.dateType = type;
  }

  toggleInactiveToFacilityFilter() {
    if (this.type === "search-order") {
      this.facilityModule.saveSearchOrderIncludeInactiveFacilities(this.isInactiveIncludeFacilities);
    } else if (this.type === "saved-search") {
      this.facilityModule.saveSavedSearchIncludeInactiveFacilities(this.isInactiveIncludeFacilities);
    }
  }

  toggleInactiveToExcludeFacilityFilter() {
    if (this.type === "search-order") {
      this.facilityModule.saveSearchOrderIncludeInactiveExcludeFacilities(
        this.isInactiveIncludeExcludeFacilities
      );
    } else if (this.type === "saved-search") {
      this.facilityModule.saveSavedSearchIncludeInactiveExcludeFacilities(
        this.isInactiveIncludeExcludeFacilities
      );
    }
  }

  get validSearchFields() {
    let filters = this.localFilter.searchFields.filter(
      (x: { name: any }) => x.name === null || this.getSelectedField(x.name) !== null
    );

    if (filters) {
      return filters.map(
        (x: { name: string | string[]; filterValues: (string | any[])[]; dateType: string }) => {
          if (x.name) {
            if (x.name.includes("Date")) {
              if (x.filterValues[0]) {
                if (x.filterValues[0].length > 15) {
                  x.dateType = "fixed";
                } else if (x.filterValues[0].length && x.filterValues[0].length < 23) {
                  x.dateType = "dynamic";
                } else {
                  this.dateType = null;
                }
              }
            }
            if (x.name === "FacilityCodes") {
              x.filterValues = JSON.parse(JSON.stringify(x.filterValues.filter(y => !!y)));
            }
          }
          return x;
        }
      );
    } else {
      return filters;
    }
  }
}
